import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import PostAddIcon from "@mui/icons-material/PostAdd";

import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import Confirm from "../../components/Confirm";
import { getTrainingDetails } from "../../api/training.deprecated";
import { deleteScheduleSlotById } from "../../api/schedule.js";
import { getEventScheduled } from "../../api/schedule";
import useCrew from "../../hooks/useCrew";

import ScheduleItem from "./scheduleItem";

const ScheduleTable = ({ match, history }) => {
  const { t } = useTranslation();
  const trainingId = match.params.trainingId;
  const eventType = match.params.eventType;
  const { crew } = useCrew();

  const [usersScheduleList, setUsersScheduleList] = useState([]);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedSlotId(id);
    setIsDeleteModalShow(true);
  }

  function onAdd(trainingId, userId, eventType) {
    history.push(`${match.url}/schedule-add/${eventType}/${trainingId}/${userId}`);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteScheduleSlotById(selectedSlotId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const trainingRes = await getTrainingDetails(trainingId);
      const usersAbleTo = await getEventScheduled(eventType, trainingId, crew.id, crew.baseIds);

      const usersAbleToEnriched = usersAbleTo.map((obj) => ({
        ...obj,
        courseName: trainingRes.displayname,
        trainingId: trainingId,
      }));
      setUsersScheduleList(usersAbleToEnriched);
    })();
  }, [refresh, crew, trainingId, eventType]);

  return (
    <>
      <h2>{t("schedule.scheduled_event", { eventType })}</h2>
      <TableComponent
        TopComponent={
          <Button size="small" onClick={() => history.push(`${match.url}/schedule-add/${eventType}/${trainingId}/all`)}>
            <PostAddIcon />
            {t("schedule.add_slot_to_all")}
          </Button>
        }
        search={["fullname", "user_id"]}
        header={[
          { title: t("training_pages.user_id"), sort: "user_id", style: { width: "5%" } },
          { title: t("user") },
          { title: t("schedule.trainer_course") },
          { title: t("location") },
          { title: t("schedule.start") },
          { title: t("schedule.end") },
          { title: t("actions"), style: { width: "7%" } },
        ]}
        renderChildren={(slots, trainingCourse) => (
          <ScheduleItem
            key={slots.user_id}
            onDelete={showDeleteModal}
            onAdd={onAdd}
            slots={slots}
            eventType={eventType}
          />
        )}
        items={usersScheduleList}
        pagination
      />
      <Button title={t("navigate_back")} type="button" onClick={() => history.goBack()}>
        {t("back")}
      </Button>
      {isDeleteModalShow && selectedSlotId && (
        <Confirm title={t("schedule.delete_slot")} onConfirm={confirmDeleteModal}>
          <p>{t("schedule.delete_slot_confirm")}</p>
        </Confirm>
      )}
    </>
  );
};

export default ScheduleTable;
